import triangleWarning from "assets/icons/triangle_exclamation.svg";
import { ContactAndTocFooter } from "components/ezpay/common/contact-and-toc-footer";
import { LOOKUP_NAMESPACE, VALIDATE_NAMESPACE } from "constants/i18n-namespaces";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Navigate } from "react-router";
import routing from "routing";
import {
  getBiller,
  getPayableSession,
  getSelectedPayableType,
} from "selectors";
import { LookupsForm } from "../lookups-form";
import { PayableCardHeader } from "../payable-card-header";

export interface ILookupsContainerProps {
  setBannerState: any;
}

export const LookupsContainer = (props: ILookupsContainerProps) => {
  const { setBannerState } = props;
  const { t } = useTranslation(VALIDATE_NAMESPACE);
  const biller = useSelector(getBiller);
  const [selectedLookupError, setSelectedLookupError] = useState(false);

  const payableTypeFromStore = useSelector(getSelectedPayableType);
  const payableSession = useSelector(getPayableSession);

  const selectedPayableType =
    payableSession?.payableType ?? payableTypeFromStore;

  if (!selectedPayableType) {
    return <Navigate to={routing.index()} />;
  }

  return (
    <div className="ez-pay-payable-frame">
      <PayableCardHeader />
      {selectedLookupError && (
        <div className="validate-error">
          <img
            src={triangleWarning}
            alt={`${t("invalid-entry")}`}
            className="validate-error-icon"
          />
          <div>
            <div className="validation-error-header">
              {t("invalid-entry")}
            </div>
            <div className="validation-error-message">
              {t("lookup-field-required", { ns: LOOKUP_NAMESPACE })}
            </div>
          </div>
        </div>
      )}

      {biller && (
        <LookupsForm
          setBannerState={setBannerState}
          biller={biller}
          selectedPayableType={selectedPayableType}
          selectedLookupError={selectedLookupError}
          setSelectedLookupError={setSelectedLookupError}
        />
      )}
      <ContactAndTocFooter biller={biller} />
    </div>
  );
};
